import ZkUserTransfer from './src/main.vue'
ZkUserTransfer.install = function (Vue) {
  Vue.component(ZkUserTransfer.name, ZkUserTransfer)
}
export default ZkUserTransfer



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/userTransfer/index.js